import { getScreenName } from '../../../../Utils/helper';

import { fireEvent } from '../../../../Utils/fireEvent';

export const viewed_share_popup = (productData) => {
  fireEvent({
    category: 'viewed_popup',
    screen_name: getScreenName(),
    parent: 'share_pdp_url',
    id: productData?.id,
    sku_nickname: productData?.name,
  });
};
export const closed_share_popup = (productData) => {
  fireEvent({
    category: 'discard_popup',
    screen_name: getScreenName(),
    parent: 'share_pdp_url_popup',
    id: productData?.id,
    sku_nickname: productData?.name,
  });
};
// export const clicked_whatsapp_share = (productData) => {
//     fireEvent({
//         category: "clicked_cta",
//         screen_name: getScreenName(),
//         parent: "share_pdp_url_popup",
//         id: productData?.id,
//         sku_nickname: productData?.name,
//         cta: "whatsapp",
//     });
// };
// export const clicked_facebook_share = (productData) => {
//     fireEvent({
//         category: "clicked_cta",
//         screen_name: getScreenName(),
//         parent: "share_pdp_url_popup",
//         id: productData?.id,
//         sku_nickname: productData?.name,
//         cta: "facebook",
//     });
// };
// export const clicked_messenger_event = (productData) => {
//     fireEvent({
//         category: "clicked_cta",
//         screen_name: getScreenName(),
//         parent: "share_pdp_url_popup",
//         id: productData?.id,
//         sku_nickname: productData?.name,
//         cta: "messenger",
//     });
// };
export const clicked_share_button = (productData) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    parent: 'share_pdp_url',
    id: productData?.id,
    sku_nickname: productData?.name,
    cta: 'share_pdp_url',
  });
};
export const clickedSocialShareIcon = (productData, ctaText) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    parent: 'share_pdp_url_popup',
    id: productData?.id,
    sku_nickname: productData?.name,
    cta: ctaText,
  });
};
